import { render } from "./FootballDetail.vue?vue&type=template&id=2dc632f5&scoped=true"
import script from "./FootballDetail.vue?vue&type=script&lang=js"
export * from "./FootballDetail.vue?vue&type=script&lang=js"

import "./FootballDetail.vue?vue&type=style&index=0&id=2dc632f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc632f5"]])

export default __exports__